import kolulaLogo from './kolula_logo.png';
import flagGermany from './flags/germany.svg';
import flagUnitedKingdom from './flags/united-kingdom.svg';

export const images = {
    flags: {
        germany: flagGermany,
        unitedKingdom: flagUnitedKingdom,
    },
    kolulaLogo,
};
